import { CommonModule } from "@angular/common";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  inject,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { IonContent, IonHeader, IonicModule } from "@ionic/angular";

import { FormsModule } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { TranslateModule } from "@ngx-translate/core";
import { BehaviorSubject, Observable, Subject, Subscription, combineLatest, of } from "rxjs";
import { switchMap, takeUntil } from "rxjs/operators";

//Services
import { EventsService } from "@providers/EventsService";
import { ScriptService } from "@providers/ScriptService";
import { StyleService } from "@providers/StyleService";
import { TrackingService } from "@providers/TrackingService";
import { BufferFacade } from "@providers/facades";
import { NewBaseService } from "@providers/newBase.service";
import { DeviceService } from "@services/device.service";
import { SportService } from "@sports-services/index";
import { SportBookService } from "@sports-services/index";
import { TicketService } from "@sports-services/index";
import { SportNavigationService } from "@sports-services/index";
import { SportsCommonService } from "@sports-services/index";

//Models
import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { DropdownMode, SixPack, eventDataModel, navigationModel } from "@sports-models/index";
import { C_BetsDataFilter, C_GameGroupByName } from "@sports-models/index";
import { C_League } from "@sports-models/index";
import { C_LeagueCategory } from "@sports-models/index";

// Components
import { CodereFooterComponent } from "@components/mso/footer/codere-footer/codere-footer";
import {
  SbCounterComponent,
  SbDropdownComponent,
  SbGridContentExpandedComponent,
  SbGridHeaderComponent,
  SbOverviewScoreRegularComponent,
  SbOverviewScoreSetsComponent,
  SbSimpleNavbarComponent,
  SbTabsCategoriesComponent,
  SbTabsComponent,
  SportsBetButtonComponent,
  SportsBetButtonWrapperColumnComponent,
  SportsGridComponent,
  SportsGridContentSingleComponent,
  SportsGridContentTeamsComponent,
  SportsGridHelperComponent,
  SportsGroupComponent,
} from "@sports-components/index";

// others
import { SportsBasePage, TrackingInfo } from "@sports-pages/index";

// Pipes
import { SportsExtractDatePipe } from "@sports-pipes/sports.extract-date.pipe";

// Stores
import { NewTicketFacade } from "@sports-features/ticket/stores";
import { SportsbookState } from "@sports-stores/sportsbook/index";
import { SportsbookFacade } from "@sports-stores/sportsbook/sportsbook.facade";
import * as sportsbookSelector from "@sports-stores/sportsbook/sportsbook.selectors";

// Utils
import { Store } from "@ngrx/store";
import { SPORTS_PATHS } from "@shared-constants/routes";
import { TicketItemTypesEnum } from "@sports-pages/ticket/utils/ticket.constants";
import { existsIn } from "@sports-services/sports.navigation.service/sports.navigation.utils";
import { SportHandleList, SportsConstants } from "@sports-utils/index";
import { ResultadosFinalesGameTypes, SCOREBOARD_TYPE } from "@sports-utils/sports.constants";

declare const SIR;
@Component({
  selector: "event-page",
  templateUrl: "./event.page.html",
  styleUrls: ["./event.page.scss"],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    SbSimpleNavbarComponent,
    SbOverviewScoreSetsComponent,
    SbOverviewScoreRegularComponent,
    SbDropdownComponent,
    SbGridHeaderComponent,
    CodereFooterComponent,
    SbGridContentExpandedComponent,
    SportsExtractDatePipe,
    TranslateModule,
    SbTabsComponent,
    SbTabsCategoriesComponent,
    SbCounterComponent,
    SportsGroupComponent,
    SportsBetButtonComponent,
    SportsGridComponent,
    SportsGridContentTeamsComponent,
    SportsGridContentSingleComponent,
    SportsBetButtonWrapperColumnComponent,
    SportsGridHelperComponent,
  ],
})
export class EventoPage extends SportsBasePage implements OnInit, OnDestroy {
  @ViewChild(IonContent) content: IonContent;
  @ViewChild(IonHeader) header: IonHeader;
  @ViewChild("standardWidgetSIR") standardWidgetSIR: ElementRef;
  @ViewChild("standardWidgetSIR2") standardWidgetSIR2: ElementRef;
  @ViewChild("stickyWidgetSIR") stickyWidgetSIR: ElementRef;

  league: C_League;
  sportHandleEvent: string;
  games$: Observable<any>;
  eventsAux$: Observable<any>;
  currentCategory$: BehaviorSubject<C_LeagueCategory> = new BehaviorSubject(null);
  gameTypes: any[] = []; // BAU: Todo: maybe this is no longer needed.
  sixPackMarket: C_GameGroupByName[]; // BAU: Todo no longer neeeded
  hasSixPack: boolean;

  hasMoreBets: boolean;
  initialFilters: C_BetsDataFilter[] = [];
  betsFilters$: BehaviorSubject<C_BetsDataFilter[]> = new BehaviorSubject(null);
  currentBetsFilter$: BehaviorSubject<C_BetsDataFilter> = new BehaviorSubject(null);

  //inside filters swipper
  gametypes = ResultadosFinalesGameTypes;
  betsCategories: any[] = [];
  showingMoreBets: boolean = false;
  hideCategories: boolean = false;
  market: any;
  markets$: Observable<any>;

  currentAddedCategory$: BehaviorSubject<C_LeagueCategory> = new BehaviorSubject(null);
  marketsResponse$: BehaviorSubject<any> = new BehaviorSubject(null);

  marketDesktopMode = DropdownMode.MARKET_DESKTOP;

  globalVars!: GlobalVarsModel;
  ngZone = inject(NgZone);
  override trackingService = inject(TrackingService);
  sportBookService = inject(SportBookService);
  newTicketFacade = inject(NewTicketFacade);
  sportService = inject(SportService);
  ticketService = inject(TicketService);
  translate = inject(TranslateService);
  styleService = inject(StyleService);
  scriptService = inject(ScriptService);
  extractDate = inject(SportsExtractDatePipe);
  bufferFacade = inject(BufferFacade);
  eventService = inject(EventsService);
  newBaseService = inject(NewBaseService);
  activatedRoute = inject(ActivatedRoute);
  deviceService = inject(DeviceService);
  route = inject(ActivatedRoute);
  renderer = inject(Renderer2);

  sportsbookFacade = inject(SportsbookFacade);
  sportsbookStore = inject(Store<SportsbookState>);
  sportNavigationService = inject(SportNavigationService);
  sportCommonService = inject(SportsCommonService);

  isMobile = false;
  isDesktop = false;
  eventData$: Observable<any>;
  eventDataSub$: Subscription;
  navigationData$: Observable<navigationModel>;
  navigationDataSub$: Subscription;
  router = inject(Router);
  widgetActive: string;

  eventMainCategories: C_LeagueCategory[];
  selectedEventMainCategory: C_LeagueCategory = null;
  eventMarkesCategories$: Observable<C_LeagueCategory[]>;
  games: [];
  event: null;
  parentId: "";
  selectedMarketsCategory: any;

  firstIterationRestore = false;
  secondIterationRestore = false;
  thirdIterationRestore = false;

  sportsNavigationId = undefined;

  stateToSave = {
    selectedEventMainCategory: undefined,
    selectedMarketsCategory: undefined,
    scrollPosition: undefined,
  };
  stateToRestore = undefined;

  private ngUnsubscribe$ = new Subject<boolean>();

  isDeepLink = false;

  SCOREBOARD_TYPE = SCOREBOARD_TYPE;

  constructor() {
    super();
    this.isDesktop = this.deviceService.isDesktop();
    this.isMobile = this.deviceService.isMobile();

    this.newBaseService.getVars
      .pipe(
        switchMap((data: GlobalVarsModel) => {
          this.globalVars = data;
          return of(null);
        }),
      )
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe();

    const currentUrl = this.sportNavigationService.navigationState$.getValue().currentUrl;
    this.isDeepLink = !!currentUrl.url.split("?")[1];
    this.sportsNavigationId = currentUrl.state.sportsNavigationId;
    this.initializePage(currentUrl.state); // necesita liga/param
    this.currentAddedCategory$.next(new C_LeagueCategory(-1, "Principal", false));

    this.eventData$ = this.sportsbookStore.select(sportsbookSelector.getEventDataState);
    this.eventDataSub$ = this.eventData$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((eventData) => {
      this.eventMainCategories = eventData?.eventMainCategories;
      this.eventMarkesCategories$ = of(eventData?.eventMarkesCategories);
      this.selectedEventMainCategory = eventData?.selectedEventMainCategory;
      this.selectedMarketsCategory = eventData?.selectedMarketsCategory;
      this.games$ = of(eventData?.games);
      this.market = eventData?.specialMarkets;
      this.betsCategories = eventData?.betsCategories;

      if (this.secondIterationRestore) {
        this.thirdIterationRestore = true;
        this.secondIterationRestore = false;
      }
      if (this.thirdIterationRestore) {
        if (eventData.eventMarkesCategories.length) {
          this.tryRestoreSelectedMarketsCategory(eventData.eventMarkesCategories);
        }
        setTimeout(() => {
          this.content.scrollToPoint(undefined, this.stateToRestore?.scrollPosition || 0, 250);
        }, 150);
        this.thirdIterationRestore = false;
      }
      const currentUrl = this.sportNavigationService.navigationState$.getValue().currentUrl;
      if (currentUrl?.popstate && eventData?.eventMainCategories && !this.firstIterationRestore) {
        this.sportsNavigationId = currentUrl.state.sportsNavigationId;
        this.stateToRestore = this.sportNavigationService.getRestoreStateFromHistory(this.sportsNavigationId);
        if (this.stateToRestore) {
          this.stateToSave = this.stateToRestore;
        }
        this.tryRestoreSelectedMainCategory(eventData?.eventMainCategories, eventData.eventMarkesCategories);
      }

      // anticipadas
      if (this.market && this.selectedEventMainCategory?.index === 1 && !eventData?.markets?.length) {
        this.sportsbookFacade.fetchEventGamesNoLive(this.market, this.league);
      }
      if (this.market && this.selectedEventMainCategory?.index === 1 && eventData?.markets?.length) {
        this.markets$ = combineLatest([this.currentAddedCategory$, of(eventData?.markets)], (current, markets) => {
          this.betsCategories = this.sportBookService.getBetsCategories(markets, this.betsCategories);
          this.showingMoreBets = true;
          this.hideCategories =
            !this.betsCategories.length ||
            (this.betsCategories.length === 1 &&
              this.betsCategories[0].CategoryId === SportsConstants.principalesCat);
          if (current.CategoryId === -1) {
            return markets;
          }
          return markets.filter((market) => {
            if (!market.CategoryInfos) {
              return false;
            } else if (market.CategoryInfos.length > 0) {
              return market.CategoryInfos.find((category) => category.CategoryId === current.CategoryId);
            }
            return current.CategoryId === 99;
          });
        });
      } else {
        this.showingMoreBets = false;
        this.markets$ = of(null);
      }
    });
  }

  ngAfterContentInit() {
    this.content?.scrollToTop();
  }

  ngOnDestroy() {
    this.unsuscribeToSubjects();
    this.sportNavigationService.injectLastStateToHistory(this.sportsNavigationId, this.stateToSave);
  }

  initializePage(state) {
    this.league = {
      ...state.params,
      SportHandleLiteral: SportHandleList[`${state.params.SportHandle}Literal`],
    };
    const eventData = new eventDataModel(null, null, null, null, null, this.league, null, null, null, null, null);

    this.sportsbookFacade.getEventData(eventData);

    this.hasMoreBets = false;
    this.hasSixPack = SixPack.validate(this.league.SportHandle, this.league.CountryCode);

    this.globalVars.hideBetFooterBar = false;
    this.content?.scrollToTop();

    this.trackingService.trackEvent([
      "SelectEvent",
      this.league.NodeId,
      this.league.SportHandle,
      this.league.Name,
      "pageView",
    ]);

    if (this.league.Name.toLowerCase() !== "fórmula 1" && this.showTournament()) {
      // for mobile use
      Promise.all([this.scriptService.load("sportradar-euro"), this.styleService.load("sportradar")]).then(() => {
        this.loadSportRadarWidget();
      });
    }
    this.eventService.publish("footer:refresh", this.content);
    setTimeout(() => this.content?.scrollToTop(), 100);
  }

  private loadSportRadarWidget() {
    const uniqueTournamentId: number = this.league.NodeId === SportsConstants.UEFAEuroNodeId ? 1 : 133;
    const disableMoreStats = false;
    const isExpanded = false;
    const disableEventTicker = true;
    const disableCompare = true;

    if (!this.showTournament()) {
      return;
    }
    SIR("addWidget", ".sr-widget-22", "tournament.preview", {
      branding: {
        tabs: {
          option: "iconText",
          iconPosition: "start",
          variant: "standard",
        },
      },
      uniqueTournamentId: uniqueTournamentId,
      disableMoreStats: disableMoreStats,
      isExpanded: isExpanded,
      disableEventTicker: disableEventTicker,
      disableCompare: disableCompare,
      isMobile: this.isMobile,
      onTrack: this.sportCommonService.onTrackSportRadarErrorLogger,
      silent: true,
    });
  }

  getTrackingInfo(): TrackingInfo {
    return {
      uri: encodeURI(`/${this.league.SportHandle}/${this.league.Name}`),
      description: `Evento page - ${this.league.Name}`,
      additionalData: {
        nodeId: this.league.NodeId,
        nodeName: this.league.Name,
        sportHandle: this.league.SportHandle,
      },
    };
  }

  public navigate(market): void {
    const componentName = market.isLive ? SPORTS_PATHS.NowLiveDetailPage : SPORTS_PATHS.MercadosPage;
    const eventType = market.isLive ? "pushEventLive" : "pushEvent";
    market = {
      ...market,
      countryCode: this.league.CountryCode,
    };
    this.unsuscribeToSubjects();
    this.router.navigate([`/${componentName}`], { state: { params: market } });

    this.trackingService.trackEvent([eventType, market.NodeId, window.location.hash, market.Name, "event"]);
  }

  public bet(game: any, event: any, gameName: string, type: string) {
    const data = {
      ...game,
      EventDate: this.extractDate.transform(event.StartDate),
      EventName: !!this.market && this.market.LeagueName.includes("Anticipadas") ? this.market.Name : event.Name,
      GameName:
        this.isMobile && event.isSixPack ? event.Games.find((i) => i.NodeId === game.GameId).Name : gameName,
    };
    this.newTicketFacade.checkSelection(data, data.NodeId, TicketItemTypesEnum.LINE_ITEM);
  }

  // CHANGE FILTERS AND CATEGORIES
  changeMainCategory(mainCategorySelected) {
    this.sportsbookFacade.setEventMainSelectedCategory(mainCategorySelected);
    this.updateLastStateToRestore(mainCategorySelected, null, undefined);
  }

  public changeCategory(value: any): void {
    this.sportsbookFacade.setEventMarketSelectedCategory(value);
    this.content?.scrollToTop();
    this.updateLastStateToRestore(undefined, value, undefined);
  }

  public showTournament() {
    return (
      this.league &&
      this.league.SportHandle === SportHandleList.soccer &&
      (this.league.NodeId === SportsConstants.UEFAEuroNodeId ||
        this.league.NodeId === SportsConstants.CopaAmericaNodeId ||
        this.league.NodeId === SportsConstants.MundialNodeId) &&
      this.globalVars.FEATURES.euroCopaWidgetEnable
    );
  }

  onScroll(ev) {
    this.updateLastStateToRestore(undefined, undefined, ev.detail.scrollTop);
  }

  resize() {
    if (!this.content) {
      return;
    }
    setTimeout(() => this.content.scrollToTop(), 200);
  }

  unsuscribeToSubjects() {
    this.ngUnsubscribe$.next(true);
    this.ngUnsubscribe$.complete();
  }

  // restoration
  tryRestoreSelectedMainCategory(eventMainCategories, eventMarkesCategories) {
    if (
      this.stateToRestore?.selectedEventMainCategory &&
      existsIn(this.stateToRestore.selectedEventMainCategory, eventMainCategories, "nodeId") &&
      this.stateToRestore.selectedEventMainCategory.nodeId !== this.selectedEventMainCategory["nodeId"]
    ) {
      this.changeMainCategory(this.stateToRestore.selectedEventMainCategory);
      this.secondIterationRestore = true;
    }
    if (
      !this.stateToRestore?.selectedEventMainCategory ||
      this.stateToRestore?.selectedEventMainCategory.nodeId === this.selectedEventMainCategory["nodeId"]
    ) {
      this.tryRestoreSelectedMarketsCategory(eventMarkesCategories);
    }
    this.firstIterationRestore = true;
  }

  tryRestoreSelectedMarketsCategory(eventMarkesCategories) {
    if (
      this.stateToRestore?.selectedMarketsCategory &&
      existsIn(this.stateToRestore.selectedMarketsCategory, eventMarkesCategories, "CategoryId")
    ) {
      this.changeCategory(this.stateToRestore.selectedMarketsCategory);
    }
    if (this.stateToRestore?.scrollPosition) {
      setTimeout(() => {
        this.content.scrollToPoint(undefined, this.stateToRestore.scrollPosition, 250);
      }, 150);
    }
    this.secondIterationRestore = false;
  }

  updateLastStateToRestore(selectedEventMainCategory, selectedMarketsCategory, scrollPosition) {
    const newStateToSave = {
      ...this.stateToSave,
    };
    if (selectedEventMainCategory !== undefined) {
      newStateToSave.selectedEventMainCategory = selectedEventMainCategory;
    }
    if (selectedMarketsCategory !== undefined) {
      newStateToSave.selectedMarketsCategory = selectedMarketsCategory;
    }
    if (scrollPosition !== undefined) {
      newStateToSave.scrollPosition = scrollPosition;
    }
    this.stateToSave = newStateToSave;
  }
}
